import i18n from 'i18n';
import React from 'react';
import ListAllCertificates from 'containers/Certificates/ListAllCertificates';
import ClientsTemplate from '../Templates/Clients';

const DigitalCertificates = () => {
  return (
    <ClientsTemplate
      current="digital-certificates"
      breadcrumbs={[
        {
          name: i18n.t('CLIENTS_KEY'),
          link: '/clients',
        },
        {
          name: i18n.t('DIGITAL_CERTIFICATES_KEY'),
        },
      ]}
    >
      <ListAllCertificates
        title={i18n.t('DIGITAL_CERTIFICATES_KEY')}
        subtitle={i18n.t('LIST_DIGITAL_CERTIFICATES_KEY')}
      />
    </ClientsTemplate>
  );
};

export default DigitalCertificates;
